// extracted by mini-css-extract-plugin
module.exports = {"page":"Cards_page__2JSyE page_page__31uF2"};